import React, { useMemo } from 'react'
import { DropdownProps } from 'semantic-ui-react'
import { Icon, SelectField, Button } from '@adc/ui-core'
import classnames from 'classnames/bind'
import styles from './styles.scss'
import { Maybe, TrusteePurchaseProfile } from '@adc/sdk/types'

const cx = classnames.bind(styles)

const TrusteePurchaseProfileSelectionWrapper = ({
  children,
  purchaseProfiles,
  onProfileSelection,
  selectedProfileId,
}: {
  children: React.ReactNode
  purchaseProfiles: Partial<TrusteePurchaseProfile>[]
  onProfileSelection: (id: string) => void
  selectedProfileId?: Maybe<string>
}) => {
  const [toggleProfileCreation, setToggleProfileCreation] =
    React.useState(false)

  const profileOptions = useMemo(() => {
    const options =
      purchaseProfiles
        ?.map(profile => {
          if (!profile?.purchase_profile_id || !profile?.profile_name) return
          return {
            key: profile.purchase_profile_id,
            text: profile.profile_name,
            value: profile.purchase_profile_id,
          }
        })
        .filter((item): item is { key: string; text: string; value: string } =>
          Boolean(item)
        ) || []
    options.unshift({
      key: 'default',
      value: '',
      text: 'Select',
    })
    return options
  }, [purchaseProfiles])

  const handleSelection = (
    _e: React.ChangeEvent<HTMLInputElement>,
    { value }: DropdownProps
  ) => {
    if (value) {
      setToggleProfileCreation(false)
      onProfileSelection(value as string)
    }
  }

  const handleToggleProfileCreation = () => {
    setToggleProfileCreation(!toggleProfileCreation)
    onProfileSelection('')
  }

  const showFormSection = toggleProfileCreation || selectedProfileId

  return (
    <div className={cx('ui', 'form')}>
      <div className={cx('profile-selection-container')}>
        <SelectField
          label='Select a Purchase Profile'
          placeholder='Select'
          options={profileOptions}
          onChange={handleSelection}
          value={selectedProfileId || ''}
        />
        <div className={cx('continue-btn')}>
          <Button role='secondary' onClick={handleToggleProfileCreation}>
            {toggleProfileCreation ? (
              'Cancel New Profile'
            ) : (
              <>
                <Icon name='add' iconStyle='regular' /> Create New
              </>
            )}
          </Button>
        </div>
      </div>
      {showFormSection && children}
    </div>
  )
}

export default TrusteePurchaseProfileSelectionWrapper
